import { useEffect, useState, useCallback, useRef } from "react";
import styled from "styled-components";
import moment from "moment";
import { Divider } from "antd";

import { rpcUrl } from "../utils/urls";
import axios from "../utils/axios";

import logoDark from "../logo-horizontal-dark.png";

const NavBarWrapper = styled.nav`
  background-color: #000;
`;

const NavBar = () => {
  // Ref
  const initialized = useRef(false);

  // State
  const [chainInfo, setChainInfo] = useState(null);
  const [epochInfo, setEpochInfo] = useState(null);
  const [totalValidators, setTotalValidators] = useState(0);

  // Fetch chain info
  const fetchChainInfo = useCallback(() => {
    const url = `${rpcUrl}/status`;

    axios
      .get(url)
      .then((response) => {
        if (response.data) {
          setChainInfo(response.data.result);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  });

  // Fetch validators
  const fetchValidators = useCallback((height, page, pageSize) => {
    const url = `${rpcUrl}/validators?height=${height}&page=${page}&per_page=${pageSize}`;

    axios
      .get(url)
      .then((response) => {
        if (response.data) {
          setTotalValidators(response.data.result.total);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  });

  // Fethc Epoch
  const fetchEpoch = useCallback(() => {
    const url = `${rpcUrl}/api/epoch-info`;
    axios
      .get(url)
      .then((response) => {
        if (response.data) {
          setEpochInfo(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  });

  useEffect(() => {
    if (!initialized.current) {
      fetchChainInfo();
      fetchEpoch();
      initialized.current = true;
    }
  }, [fetchChainInfo, fetchEpoch]);

  useEffect(() => {
    if (chainInfo) {
      fetchValidators(chainInfo.sync_info.latest_block_height - 1, 1, 1);
    }
  });

  const getBlockTimePastTime = useCallback(() => {
    if (chainInfo) {
      const blockTime = chainInfo.sync_info.latest_block_time;
      const pastTime = moment(blockTime).fromNow();

      return pastTime;
    }

    return "-";
  }, [chainInfo]);

  const getNextEpochInfo = useCallback(() => {
    const earliestNextEpochBlockHeight =
      epochInfo?.earliest_next_epoch_block_height;

    const currentBlockHeight = chainInfo?.sync_info.latest_block_height - 1;

    if (earliestNextEpochBlockHeight && currentBlockHeight) {
      return earliestNextEpochBlockHeight - currentBlockHeight;
    }

    return "-";
  }, [epochInfo]);

  const renderChainInfo = () => {
    return (
      <div style={{ display: "flex", padding: "0", fontSize: "14px" }}>
        <div style={{ color: "#fff" }}>
          <strong>Chain:</strong> shielded-expedition.88f17d1d14
        </div>
        <Divider
          type="vertical"
          style={{ height: "16px", background: "white" }}
        />
        <div style={{ color: "#fff" }}>
          <strong>Current Block:</strong>{" "}
          {chainInfo?.sync_info.latest_block_height - 1 ?? "-"}
        </div>
        <Divider
          type="vertical"
          style={{ height: "16px", background: "white" }}
        />
        <div style={{ color: "#fff" }}>
          <strong>Latest Block:</strong> {getBlockTimePastTime()}
        </div>

        <Divider
          type="vertical"
          style={{ height: "16px", background: "white" }}
        />
        <div style={{ color: "#fff" }}>
          <strong>Epoch:</strong> {epochInfo?.last_committed_epoch ?? "-"}
        </div>
        <Divider
          type="vertical"
          style={{ height: "16px", background: "white" }}
        />
        <div style={{ color: "#fff" }}>
          <strong>Next Epoch Infomation:</strong> {getNextEpochInfo()} blocks
        </div>
        <Divider
          type="vertical"
          style={{ height: "16px", background: "white" }}
        />
        <div style={{ color: "#fff" }}>
          <strong>Total Validators:</strong> {totalValidators}
        </div>
      </div>
    );
  };

  return (
    <NavBarWrapper>
      <div
        style={{
          display: "flex",
          padding: "0 32px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={logoDark} alt="logo" width={160} />
        <div style={{ marginLeft: "auto" }}>{renderChainInfo()}</div>
      </div>
    </NavBarWrapper>
  );
};

export default NavBar;
